import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({})
export default class Language extends Mixins<MixinInterface>() {
    get languages() {
        return Object.values(this.$store.getters.languages).filter((language: any) => {
            return language.availableForUsers
        })
    }

    get language() {
        return this.$store.getters.userLanguage
    }

    set language(data: string) {
        this.$store.commit('userLanguage', data)
    }
}
